import React, { useState } from 'react';
import './newAssessment.scss';
import NewAssessmentForm from '../new-assessment-form/NewAssessmentForm';
import Header from '../../../layout/header/Header';
import { useLocation } from 'react-router-dom';

const NewAssessment = () => {
  const location = useLocation();
  const fromProjectReadiness = location.state?.fromProjectReadiness === true;

  return (
    <div className="newAssessmentContainer">
      <Header showBackLink={true} fromProjectReadiness={fromProjectReadiness} />
      <NewAssessmentForm />
    </div>
  );
};

export default NewAssessment;
